import { connect } from "react-redux";
import { Dispatch } from "redux";
import { assignPageSelectors } from "../../../pages/assign";
import { assignPageActions } from "../../../pages/assign";
import { employeesSelector } from "../../../store/employees.store";
import { groupsSelector } from "../../../store/groups.store";
import { RootState } from "../../../store/index.store";
import { dialogPropsSelector, uiActions } from "../../../store/ui.store";
import {
  JobEditDialog as JobEditDialogComponent,
  jobEditFormId
} from "./JobEditDialog";

const mapStateToProps = (state: RootState) => ({
  dialogProps: dialogPropsSelector(state),
  initialValues: assignPageSelectors.getSelectedJob(state),
  groups: groupsSelector(state),
  employees: employeesSelector(state)
});

const mapStateToDispatch = (dispatch: Dispatch) => ({
  close: () =>
    dispatch(uiActions.SYSTEM_CLOSE_DIALOG({ formId: jobEditFormId })),
  submit: (values: any) =>
    dispatch(
      assignPageActions.USER_CLICKED_JOB_REGISTER_BUTTON({ jobForm: values })
    )
});

export const JobEditDialog = connect(
  mapStateToProps,
  mapStateToDispatch
)(JobEditDialogComponent);
